import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ScriptModule = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="4"
            y="5"
            width="16"
            height="14"
            rx="2"
            fill="url(#paint0_linear_123_17412)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 10L11 14L13 10Z"
            fill="url(#paint1_linear_123_17412)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.2236 9.5529C13.4706 9.67639 13.5707 9.97673 13.4472 10.2237L11.4472 14.2237C11.3237 14.4707 11.0234 14.5708 10.7764 14.4473C10.5294 14.3238 10.4293 14.0235 10.5528 13.7765L12.5528 9.7765C12.6763 9.52951 12.9766 9.4294 13.2236 9.5529Z"
            fill="#1C0558"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.1464 10.1464C15.3417 9.95118 15.6583 9.95118 15.8536 10.1464L17.1613 11.4542C17.4627 11.7556 17.4627 12.2444 17.1613 12.5458L15.8536 13.8536C15.6583 14.0488 15.3417 14.0488 15.1464 13.8536C14.9512 13.6583 14.9512 13.3417 15.1464 13.1464L16.2929 12L15.1464 10.8536C14.9512 10.6583 14.9512 10.3417 15.1464 10.1464Z"
            fill="#1C0558"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.85358 10.1464C9.04884 10.3417 9.04884 10.6583 8.85358 10.8536L7.70714 12L8.85358 13.1464C9.04884 13.3417 9.04884 13.6583 8.85358 13.8536C8.65832 14.0488 8.34174 14.0488 8.14648 13.8536L6.83877 12.5458C6.53731 12.2444 6.53731 11.7556 6.83877 11.4542L8.14648 10.1464C8.34174 9.95118 8.65832 9.95118 8.85358 10.1464Z"
            fill="#1C0558"
          />
          <defs>
            <linearGradient
              id="paint0_linear_123_17412"
              x1="12"
              y1="5"
              x2="12"
              y2="19"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#A680FF" />
              <stop offset="1" stop-color="#17FF6D" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_123_17412"
              x1="12.2189"
              y1="10"
              x2="12.2189"
              y2="14.3511"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#9C74C8" />
              <stop offset="1" stop-color="#8451BF" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ScriptModule;
